import { useState, useEffect, useMemo } from "react";
import { Select } from "antd";
import PageHeader from "../components/PageHeader";
import { useTranslation } from "react-i18next";
import "./DigitalLibrary.css";
import granthalayBooks from "../assets/images/granthalayBooks.png";
import { Link } from "react-router-dom";
import whiteDownloadIcon from "../assets/icons/download_white.svg";
import Heading from "../components/Heading";
import VillageIllustration from "../components/VillageIllustration";
import axiosInstance from "../services/axios";

const { Option } = Select;

export default function DigitalLibrary() {
  const { t, i18n } = useTranslation();

  const [books, setBooks] = useState([]);          // Digital books from static data
  const [physicalBooks, setPhysicalBooks] = useState([]); // Optional physical books
  const [selectedFormat, setSelectedFormat] = useState("All");

  // Static book data - memoized to prevent recreation on every render
  const staticBooksData = useMemo(() => [
    {
      id: 1,
      title: "पावन खिंड",
      shortDescription: "मराठी साहित्यातील एक उत्कृष्ट कादंबरी जी वीरता, त्याग आणि देशप्रेमाच्या भावनांना उजागर करते. हा ग्रंथ महान योद्ध्यांच्या गाथा सांगतो आणि वाचकांना प्रेरणा देतो. प्रत्येक पानावर इतिहासाची खोली दिसते.",
      downloadCount: 1250,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Paavan-Khind.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Paavan-Khind.pdf",
    },
    {
      id: 2,
      title: "The Power of Habit",
      shortDescription: "सवयींची शक्ती आणि त्यांचा जीवनावर होणारा गंभीर परिणाम समजावून सांगणारे पुस्तक. चार्ल्स डुहिग यांनी वैज्ञानिक संशोधनाच्या आधारे चांगल्या सवयी कशा निर्माण करता येतात हे स्पष्ट केले आहे. जीवनात यशस्वी होण्यासाठी आवश्यक मार्गदर्शन.",
      downloadCount: 2100,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Power-of-Habit.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Power-of-Habit.pdf",
    },
    {
      id: 3,
      title: "Think and Grow Rich (मराठी)",
      shortDescription: "नेपोलियन हिलच्या जगप्रसिद्ध पुस्तकाचे मराठी भाषांतर. श्रीमंत बनण्याचे मानसिक तंत्र, यशाची मानसिकता आणि संपत्ती निर्माणाची रहस्ये उलगडणारे हे पुस्तक. व्यावसायिक यश मिळवण्यासाठी अत्यावश्यक असलेली माहिती आणि तंत्रे.",
      downloadCount: 1800,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Think-and-Grow-Rich-Marathi.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/Think-and-Grow-Rich-Marathi.pdf",
    },
    {
      id: 4,
      title: "The Richest Man in Babylon (मराठी)",
      shortDescription: "प्राचीन बॅबिलोनच्या काळातील संपत्ती निर्माणाचे तत्त्व आणि आर्थिक शहाणपणाची गाथा. जॉर्ज क्लेसनच्या या पुस्तकात पैसे कसे वाचवावे, गुंतवणूक कशी करावी आणि आर्थिक स्वातंत्र्य कसे मिळवावे याचे प्राचीन तत्त्व सांगितले आहे.",
      downloadCount: 1650,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/the-richest-man-in-babylon-marathi.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/the-richest-man-in-babylon-marathi.pdf",
    },
    {
      id: 5,
      title: "अभ्यासात यश मिळणारच",
      shortDescription: "शिक्षणात यशस्वी होण्याचे वैज्ञानिक मार्गदर्शन आणि अभ्यासाची योग्य पद्धत. विद्यार्थ्यांसाठी अत्यंत उपयुक्त असलेली ही पुस्तक परीक्षेत चांगले गुण मिळवण्याची तंत्रे, वेळेचे व्यवस्थापन आणि स्मृतिशक्ती वाढवण्याचे उपाय सांगते.",
      downloadCount: 1420,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/अभ्यासात%20यश%20मिळणारच.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/अभ्यासात यश मिळणारच.pdf",
    },
    {
      id: 6,
      title: "इनर इंजिनिअरिंग",
      shortDescription: "सद्गुरू जग्गी वासुदेव यांचे आध्यात्मिक मार्गदर्शन आणि आंतरिक विकासाचे साधन. मानसिक शांती, तणाव कमी करण्याचे तंत्र आणि आनंदी जीवन जगण्याचे मार्ग शोधणारे हे पुस्तक. योग आणि ध्यानाच्या सहाय्याने जीवनात संतुलन निर्माण करण्याचे उपाय.",
      downloadCount: 1750,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/इंनर%20इंजिनिअरिंग.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/इंनर इंजिनिअरिंग.pdf",
    },
    {
      id: 7,
      title: "मनाचे चमत्कार",
      shortDescription: "मानसिक शक्तीचा विस्तार आणि मनाच्या अद्भुत क्षमतांचे रहस्य उलगडणारे पुस्तक. सकारात्मक विचारांची शक्ती, आत्मविश्वास वाढवण्याचे तंत्र आणि मनःशक्तीने जीवनात बदल घडवून आणण्याचे मार्ग. मानसिक आरोग्यासाठी अत्यंत उपयुक्त.",
      downloadCount: 1590,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/मनाचे%20चमत्कार.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/मनाचे चमत्कार.pdf",
    },
    {
      id: 8,
      title: "यशाची मास्टर की",
      shortDescription: "यशस्वी जीवनाची गुरुकिल्ली आणि व्यक्तिमत्व विकासाचे मूलभूत तत्त्व. नेतृत्व गुण, संवाद कौशल्य आणि व्यावसायिक यशासाठी आवश्यक असलेली सर्व गुणवत्ता वाढवण्याचे मार्ग. जीवनातील प्रत्येक क्षेत्रात यशस्वी होण्यासाठी प्रेरणादायी मार्गदर्शन.",
      downloadCount: 1680,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/यशाची%20मास्टर%20की.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/यशाची मास्टर की.pdf",
    },
    {
      id: 9,
      title: "शहीद भगतसिंग यांचे तरुणांना आव्हान",
      shortDescription: "महान स्वातंत्र्यसैनिक शहीद भगतसिंग यांच्या विचारांचे संकलन आणि तरुण पिढीसाठी देशभक्तीचे संदेश. क्रांतिकारक विचारधारा, न्याय आणि समानतेचे तत्त्व सांगणारे हे पुस्तक. देशसेवेची भावना जागृत करणारे प्रेरणादायी लेखन आणि तत्त्वज्ञान.",
      downloadCount: 1340,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/शहीद_भगतसिंग_यांचे_तरुणांना_आव्हाहन.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/शहीद_भगतसिंग_यांचे_तरुणांना_आव्हाहन.pdf",
    },
    {
      id: 10,
      title: "श्यामची आई",
      shortDescription: "सत्यजित रे यांच्या या प्रसिद्ध कथेचे मराठी रूपांतर जे मातृत्वाची महत्ता आणि आईच्या निस्वार्थ प्रेमाची गाथा सांगते. कुटुंबातील नातेसंबंधांचे गूढ चित्रण आणि भावनिक गहनता असलेली ही कथा. मानवी संवेदनांचे सुंदर चित्रण करणारे साहित्य.",
      downloadCount: 1480,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/श्यामची%20आई.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/श्यामची आई.pdf",
    },
    {
      id: 11,
      title: "सुखाचा शोध",
      shortDescription: "आनंदी आणि समाधानकारक जीवन जगण्याचे मार्ग आणि सुखाचा खरा अर्थ समजावून सांगणारे पुस्तक. तणावमुक्त जीवन, मानसिक शांती आणि आंतरिक समाधान मिळवण्याचे तत्त्व. दैनंदिन जीवनातील छोट्या गोष्टींमध्ये आनंद शोधण्याचे कलेचे मार्गदर्शन.",
      downloadCount: 1620,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/सुखाचा%20शोध.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/सुखाचा शोध.pdf",
    },
    {
      id: 12,
      title: "स्टीव्ह जॉब्स",
      shortDescription: "तंत्रज्ञान क्रांतीचे जनक स्टीव्ह जॉब्स यांचे प्रेरणादायी जीवनचरित्र आणि त्यांच्या नाविन्यपूर्ण विचारांची गाथा. Apple कंपनीची स्थापना, iPhone चा शोध आणि तंत्रज्ञान जगातील त्यांच्या क्रांतिकारक कामगिरीचे वर्णन. उद्यमिता आणि नेतृत्वाचे अनमोल धडे.",
      downloadCount: 1890,
      format: "PDF",
      cover: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/स्टीव्ह%20जॉब्स.jpg",
      pdf: "https://raw.githubusercontent.com/jawaharlalnehru1988/bgsloka/master/assets/village-libraries/स्टीव्ह जॉब्स.pdf",
    },
  ], []);

  // Static physical books data - memoized to prevent recreation on every render
  const staticPhysicalBooksData = useMemo(() => [
    {
      id: 1,
      title: "श्रीमंत योगी",
      shortDescription: "साध्या जीवनातून महान बनण्याची प्रेरणादायी कथा जी आध्यात्मिक विकासाचे मार्गदर्शन करते आणि जीवनातील खऱ्या यशाचे रहस्य उलगडते. आंतरिक शांती आणि समाधान मिळवण्याचे उपाय शिकवणारे हे पुस्तक आत्मचिंतन करण्यास प्रवृत्त करते.",
      cover: granthalayBooks
    },
    {
      id: 2,
      title: "मृत्युंजय",
      shortDescription: "वीर सावरकरांचे संपूर्ण जीवनचरित्र आणि स्वातंत्र्यसैनिकाच्या अदम्य संघर्षाची गाथा. देशभक्ती, बलिदान आणि राष्ट्रसेवेची भावना जागृत करणारे हे पुस्तक त्यांच्या विचारधारेचे सखोल चित्रण करते आणि तरुणांना प्रेरणा देते.",
      cover: granthalayBooks
    },
    {
      id: 3,
      title: "राधेय",
      shortDescription: "महाभारतातील महान योद्धा कर्णाची वीरगाथा जी वीरता, त्याग आणि धर्माधर्माच्या संघर्षाचे उत्कृष्ट उदाहरण मांडते. जन्माने दलित पण गुणाने श्रेष्ठ असलेल्या कर्णाच्या व्यक्तिमत्वाचे गहन चित्रण करणारे महाकाव्य.",
      cover: granthalayBooks
    },
    {
      id: 4,
      title: "छावा",
      shortDescription: "छत्रपती संभाजी महाराजांचे वीर चरित्र आणि मराठा साम्राज्याच्या शौर्याची गौरवगाथा. पिताच्या पावलावर चालून स्वराज्य रक्षणाचे काम करणाऱ्या संभाजीराजांच्या पराक्रमाची आणि त्यागाची अमर कहाणी जी आजही प्रेरणा देते.",
      cover: granthalayBooks
    },
    {
      id: 5,
      title: "झुंज",
      shortDescription: "ग्रामीण जीवनातील संघर्षाची खऱ्या अर्थाने चित्रित करणारी कहाणी जी सामाजिक बदलाचे आणि प्रगतीचे चित्रण करते. शेतकरी जीवनाचे वास्तव, त्यांच्या समस्या आणि त्यावरील उपाययोजना दाखवणारे साहित्य जे वाचकांना विचार करायला लावते.",
      cover: granthalayBooks
    },
    {
      id: 6,
      title: "व्यक्ती आणि वल्ली",
      shortDescription: "महान पुराणपुरुषांच्या व्यक्तिरेखा आणि त्यांच्या जीवनातील महत्वाच्या घटनांची विस्तृत माहिती देणारे पुस्तक. इतिहासप्रसिद्ध व्यक्तींच्या संघर्षाची, यशाची आणि त्यांच्या योगदानाची गाथा सांगणारे मूल्यवान साहित्य जे प्रेरणा देते.",
      cover: granthalayBooks
    },
    {
      id: 7,
      title: "आपल्या मराठी भाषेचा इतिहास",
      shortDescription: "मराठी भाषेचा संपूर्ण ऐतिहासिक विकास, साहित्य परंपरा आणि सांस्कृतिक वारशाचा सखोल अभ्यास करणारे पुस्तक. मराठी भाषेच्या उत्पत्तीपासून आजपर्यंतच्या प्रवासाची आणि त्यातील महत्वाच्या साहित्यिकांच्या योगदानाची माहिती.",
      cover: granthalayBooks
    },
    {
      id: 8,
      title: "माझे गुरु",
      shortDescription: "महान गुरुंच्या स्मृती आणि त्यांच्या उपदेशांचे आध्यात्मिक संकलन जे जीवनाला दिशा देते. आध्यात्मिक मार्गदर्शन, जीवनमूल्ये आणि मानवी गुणधर्मांचा विकास करण्यासाठी आवश्यक असलेले तत्त्वज्ञान आणि व्यावहारिक सूत्रे समाविष्ट केलेली.",
      cover: granthalayBooks
    }
  ], []);

  // Load data from API, fallback to static data
  useEffect(() => {
    const fetchDigitalLibrary = async () => {
      try {
        const language = i18n.language === 'mr' ? 'Marathi' : 'English';
        const response = await axiosInstance.get('/digital-library/', {
          params: { language }
        });
        
        const data = response.data;
        console.log('Digital Library API response:', data);
        
        if (data && data.length > 0) {
          // Map API data to component format
          const mappedBooks = data.map(item => ({
            id: item.id,
            title: item.name,
            shortDescription: item.description || '',
            cover: item.cover_image || granthalayBooks,
            pdf: item.pdf || '',
            format: 'PDF',
            downloadCount: 0,
          }));
          setBooks(mappedBooks);
        } else {
          // Use static data if no API data
          setBooks(staticBooksData);
        }
      } catch (err) {
        console.error('Error fetching digital library:', err);
        // Fallback to static data on error
        setBooks(staticBooksData);
      }
    };

    const fetchVillageBooks = async () => {
      try {
        const language = i18n.language === 'mr' ? 'Marathi' : 'English';
        const response = await axiosInstance.get('/village-books/', {
          params: { language }
        });
        
        const data = response.data;
        console.log('Village Books API response:', data);
        
        if (data && data.length > 0) {
          // Map API data to component format
          const mappedBooks = data.map(item => ({
            id: item.id,
            title: item.name,
            shortDescription: item.description || '',
            cover: item.cover_image || granthalayBooks,
          }));
          setPhysicalBooks(mappedBooks);
        } else {
          // Use static data if no API data
          setPhysicalBooks(staticPhysicalBooksData);
        }
      } catch (err) {
        console.error('Error fetching village books:', err);
        // Fallback to static data on error
        setPhysicalBooks(staticPhysicalBooksData);
      }
    };

    fetchDigitalLibrary();
    fetchVillageBooks();
  }, [i18n.language, staticBooksData, staticPhysicalBooksData]);

  const formats = ["All", "PDF", "EPUB", "DOCX", "MOBI"];

  const handleFormatChange = (value) => setSelectedFormat(value);

  const handleDownload = (book) => {
    if (book.pdf) {
      window.open(book.pdf, "_blank");
    }
  };

  const filteredBooks =
    selectedFormat === "All"
      ? books
      : books.filter((b) => b.format === selectedFormat);

  return (
    <>
      <div className="digital-library section-padding bg-image-section">
        <PageHeader
          breadcrumb={[
            <Link key="home" to="/">
              {t("home.breadcrumb")}
            </Link>,
            <span key="digital-library">
              {t("digitalLibrary.breadcrumb")}
            </span>,
          ]}
          title={t("digitalLibrary.title")}
          description={t("digitalLibrary.description")}
          actions={
            <Select
              value={selectedFormat}
              onChange={handleFormatChange}
              style={{ width: 160 }}
            >
              {formats.map((f) => (
                <Option key={f} value={f}>
                  {f}
                </Option>
              ))}
            </Select>
          }
        />

        <div className="dl-grid">
          {filteredBooks.map((book) => (
            <div className="dl-card" key={book.id}>
              <div
                className="dl-cover"
                style={{ backgroundImage: `url(${book.cover})` }}
              />
              <div className="dl-card-body">
                <h3 className="dl-card-title">{book.title}</h3>
                <p className="dl-card-desc">{book.shortDescription}</p>
              </div>
              <div className="dl-card-footer">
                <button
                  className="dl-download-btn"
                  onClick={() => handleDownload(book)}
                >
                  <img
                    src={whiteDownloadIcon}
                    alt="Download"
                    style={{
                      width: 18,
                      height: 18,
                      marginRight: 8,
                      verticalAlign: "middle",
                    }}
                  />
                  {t("Download") || "Download"}
                </button>
                <div className="dl-download-count">
                  {book.downloadCount}+ {t("Downloads")}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Physical Books (optional) */}
        <div className="dl-section-divider"></div>
        <div className="my-4">
          <Heading content={t("Physical Local Library")} />
        </div>

        <div className="dl-grid">
          {physicalBooks.map((book) => (
            <div className="dl-card" key={book.id}>
              <div
                className="dl-cover"
                style={{ backgroundImage: `url(${book.cover})` }}
              />
              <div className="dl-card-body">
                <h3 className="dl-card-title">{book.title}</h3>
                <p className="dl-card-desc">{book.shortDescription}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <VillageIllustration  />
    </>
  );
}
